import { render } from "./AccountNotifications.vue?vue&type=template&id=25561e60"
import script from "./AccountNotifications.vue?vue&type=script&lang=js"
export * from "./AccountNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__